export const gforms = () => {

  $(document).on( 'gform_post_render', function() {
    $('input, textarea, select').each(function () {
      var $input = $(this);
      var hasValue = $input.val();
      if (hasValue != '' && hasValue != '(___) ___-____') {
        //note: accounts for tel input mask
        $input.parents('.gfield').addClass('has_value');
      } else {
        $input.parents('.gfield').removeClass('has_value');
      }
    });
  })

  $('input, textarea, select')
    .on('change blur', function () {
      var $input = $(this);
      var hasValue = $input.val();


      if (hasValue != '' && hasValue != '(___) ___-____') {
        //note: accounts for tel input mask
        $input.parents('.gfield').addClass('has_value');
      } else {
        $input.parents('.gfield').removeClass('has_value');
      }
    });

};
